import { useCallback, useMemo } from 'react';

const useRedemptionUnit = ({ dispatch, value, initValue, clearBudget }) => {
  const onChange = useCallback(
    (selectedUnit) => {
      dispatch({ type: 'REDEMPTION_UNIT_CHANGE', payload: selectedUnit.value });
      clearBudget();
    },
    [dispatch, clearBudget]
  );

  return useMemo(
    () => ({ value, defaultValue: initValue, onChange, isChanged: initValue !== value }),
    [value, onChange, initValue]
  );
};

export default useRedemptionUnit;
